import conf from '~/app/conf'

/**
 * @from weberus/packages/feature-flag
 */
export interface EnvConfig {
  local: boolean
  dev: boolean
  qa: boolean
  stage: boolean
  prod: boolean
}

export type FeatureFlagEnv = keyof EnvConfig

export type FeatureFlags<K extends string> = Record<K, EnvConfig | boolean>

export const featureFlagEnv =
  process.env.NODE_ENV === 'development' ? 'local' : (conf.environment as keyof EnvConfig)

const isEnvConfig = (feature: unknown): feature is EnvConfig => {
  return (
    !!feature &&
    typeof feature === 'object' &&
    'dev' in feature &&
    'qa' in feature &&
    'stage' in feature &&
    'prod' in feature
  )
}

class FeatureFlagService<K extends string> {
  constructor(featureFlagsConfig: Record<K, EnvConfig>, environment: FeatureFlagEnv) // env가 있는 경우 - project
  constructor(
    private readonly featureFlagsConfig: FeatureFlags<K>,
    private readonly environment?: FeatureFlagEnv
  ) {}

  isFeatureEnabled(featureName: K): boolean {
    const feature = this.featureFlagsConfig[featureName]

    if (typeof feature === 'boolean' || this.environment === undefined) {
      // env가 없는 경우 - package
      return !!feature
    }

    if (isEnvConfig(feature)) {
      // env가 있는 경우 - project
      return feature[this.environment] || false
    }
    throw new Error(`잘못된 feature flag 입니다. flag: ${featureName}`)
  }
}

export { FeatureFlagService }
